import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=ae508d0e&"
import script from "./FileUploaderVue.ts?vue&type=script&lang=ts&"
export * from "./FileUploaderVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports